// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { FacebookInverted as FacebookIcon } from '@zocdoc-frontend-common/assets-icons';

import BaseSocialLoginButton, { IconContainer } from './BaseSocialLoginButton';

export default function FacebookLoginButton({
    message = 'Continue with Facebook',
    ...props
}) {
    return (
        <StyledLoginButton icon={FacebookIcon} message={message} {...props} />
    );
}

const StyledLoginButton = styled(BaseSocialLoginButton)`
    background-color: #4267b2;

    ${IconContainer} {
        font-size: 24px;
    }

    &:hover,
    &:active {
        background-color: #314d99;
    }
`;
